import { Injectable } from "@angular/core";
import { ListElementEnum } from "../enums/listElementEnum";
import { Observable } from "rxjs";
import { BaseService } from "./base.service";
import { ListElement } from "../models/list-element";

@Injectable({
  providedIn: "root",
})
export class ListService {
  constructor(private _baseService: BaseService) {}

  public GetListElements(listId: ListElementEnum): Observable<ListElement[]> {
    return this._baseService.get(`stock/GetDropdownValue?listId=${listId}`);
  }
}
